import Image from 'next/image'
import Link from 'next/link'
import cl from 'classnames'

type Props = {
  className?: string
}

export const MenuContentMercadoLivre = ({ className }: Props) => {
  return (
    <div
      className={cl(
        `relative w-full h-60 rounded-2xl overflow-hidden`,
        className
      )}
    >
      <Image
        src="/assets/new/bannerML.webp"
        alt="Entrega no Mercado Livre de Energia com o Portal Solar"
        fill
        quality={100}
        className="object-cover object-right"
      />

      <div className="absolute left-10 top-14 flex flex-col gap-7">
        <p className="w-[460px] h-[72px] text-[40px] leading-[44px] tracking-[0.8px] font-light text-white">
          Entre no Mercado Livre de Energia com o Portal Solar
        </p>
        <Link
          href="/mercado-livre-de-energia"
          className="w-fit h-10 flex items-center justify-center bg-gradient-to-r from-v3-orange-350 to-v3-orange-500 hover:brightness-105 text-base leading-4 tracking-[1.2px] font-semibold uppercase rounded-full px-6 transition duration-300"
        >
          Garanta segurança e economia
        </Link>
      </div>
    </div>
  )
}
